/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Err_SendInputs */

const en_signin_err_send = /** @type {(inputs: Signin_Err_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not send the code. Try again in a moment.`)
};

const id_signin_err_send = /** @type {(inputs: Signin_Err_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode gagal dikirim. Coba lagi sebentar lagi.`)
};

/**
* | output |
* | --- |
* | "We could not send the code. Try again in a moment." |
*
* @param {Signin_Err_SendInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_err_send = /** @type {((inputs?: Signin_Err_SendInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Err_SendInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_err_send(inputs)
	return en_signin_err_send(inputs)
});